var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUseredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 8.00001C8.88404 8.00001 9.73189 7.64882 10.357 7.0237C10.9821 6.39858 11.3333 5.55073 11.3333 4.66668C11.3333 3.78262 10.9821 2.93478 10.357 2.30965C9.73189 1.68453 8.88404 1.33334 7.99999 1.33334C7.11593 1.33334 6.26809 1.68453 5.64297 2.30965C5.01785 2.93478 4.66666 3.78262 4.66666 4.66668C4.66666 5.55073 5.01785 6.39858 5.64297 7.0237C6.26809 7.64882 7.11593 8.00001 7.99999 8.00001Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8067 10.4933L10.4467 12.8533C10.3533 12.9467 10.2667 13.12 10.2467 13.2467L10.12 14.1467C10.0733 14.4733 10.3 14.7 10.6267 14.6533L11.5267 14.5267C11.6533 14.5067 11.8333 14.42 11.92 14.3267L14.28 11.9667C14.6867 11.56 14.88 11.0867 14.28 10.4867C13.6867 9.89334 13.2133 10.0867 12.8067 10.4933Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4667 10.8333C12.6667 11.5533 13.2267 12.1133 13.9467 12.3133",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27335 14.6667C2.27335 12.0867 4.84001 10 8.00001 10C8.69335 10 9.36001 10.1 9.98001 10.2867",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseredit);
export default __webpack_public_path__ + "static/media/useredit.6aa7698ff961b8244480f41341834f21.svg";
export { ForwardRef as ReactComponent };